const ArrowDownIcon = ({ ...props }) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.64645 15.8535C5.45118 15.6582 5.45118 15.3417 5.64645 15.1464L6.35355 14.4393C6.54882 14.244 6.8654 14.244 7.06066 14.4393L12 19.3786L16.9393 14.4393C17.1346 14.244 17.4512 14.244 17.6464 14.4393L18.3536 15.1464C18.5488 15.3417 18.5488 15.6582 18.3536 15.8535L12.3536 21.8535C12.1583 22.0488 11.8417 22.0488 11.6464 21.8535L5.64645 15.8535Z"
			fill="currentColor"
		/>
		<rect
			x="13"
			y="20"
			width="2"
			height="18"
			rx="0.5"
			transform="rotate(-180 13 20)"
			fill="currentColor"
		/>
	</svg>
)

export default ArrowDownIcon
